import { post ,get} from "../network/index.js";
//商家家政员管理 --> 分页查询商家家政员列表
const listHomemaking = (data) => {
  return post("/mercWebi/webHomemaking/listHomemaking", data);
};
//新增家政员信息
const insertFullReduce = (data) => {
  return post("/mercWebi/webHomemaking/insertFullReduce", data);
};
//打开所属店铺的信息
const listStoreInfoByAccountId = (data) => {
  return post("/mercWebi/busStoreInfo/listStoreInfoByAccountId", data);
};
//通过手机号查询
const listHomemakingByPhone = (data) => {
  return get("/mercWebi/webHomemaking/listHomemakingByPhone", data);
};

//商家家政员管理 --> 获取家政员详情
const listHomemakingById = (data) => {
  return get("/mercWebi/webHomemaking/listHomemakingById", data);
};

//商家家政员管理 --> 查询家政员适用店铺列表
const listHomemakingStores = (data) => {
  return get("/mercWebi/webHomemaking/listHomemakingStores", data);
};

//商家家政员管理 --> 修改家政员信息
const modifyHomemaking = (data) => {
  return post("/mercWebi/webHomemaking/modifyHomemaking", data);
};
//商家家政员管理 --> 商家绑定家政员信息
const bindHomemaking = (data) => {
  return post("/mercWebi/webHomemaking/bindHomemaking", data);
};


export default {
    listHomemaking,
    insertFullReduce,
    listStoreInfoByAccountId,
    listHomemakingByPhone,
    listHomemakingById,
    listHomemakingStores,
    modifyHomemaking,
    bindHomemaking
};
